module.exports = __webpack_public_path__ + "img/companyBg2.5d0d12fc.jpg";